import styled from 'styled-components';
import { container, spacing } from '../../theme';

export const StyledManfredite = styled.div`
  margin: ${spacing('xl4')} auto;
  max-width: ${container('xl')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
`;
